<template>
  <div class="discount-detail">
    <div class="charts">
      <div class="total-charts">
        <e-chart :options="totalChartsOptions"/>
      </div>
      <div class="total-charts">
        <e-chart :options="totalUsedChartsOptions"/>
      </div>
    </div>
    <el-form :inline="true" ref="search" class="demo-form-inline">
      <el-form-item prop="order_no">
        <el-input v-model="keywords" placeholder="请输入领取人姓名/手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="handleSend">发放</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column prop="coupon_no" label="优惠券编号" align="center"/>
      <el-table-column prop="create" label="领取人/时间" align="center">
        <template slot-scope="{ row: { tel, created_at }}">
          {{ tel }}<br>{{created_at}}
        </template>
      </el-table-column>
      <el-table-column prop="create" label="发放人" align="center">
        <template slot-scope="{ row: { username, created_at }}">
          {{ username }}<br>{{ created_at }}
        </template>
      </el-table-column>
      <el-table-column prop="used_at" label="状态" align="center">
        <template slot-scope="{ row: { status}}">
          {{ status ? '已使用' : '未使用' }}
        </template>
      </el-table-column>
      <el-table-column prop="order_no4" label="订单信息" align="center"/>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <send-discount ref="sendDiscount" @update="init"/>
  </div>
</template>

<script>
import EChart from '../../../components/echart/index'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { fetchCouponDetail } from '../../../api'
import SendDiscount from '../components/SendDiscount'

export default {
  name: 'DiscountDetail',
  components: { SendDiscount, EChart },
  data() {
    return {
      id: null,
      totalChartsOptions: {
        title: {
          text: '优惠券总量',
          left: 'center',
          bottom: '0'
        },
        tooltip: {
          // trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'right'
        },
        series: [
          {
            name: '优惠券总数',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 0, name: '已发放' },
              { value: 0, name: '未发放' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      totalUsedChartsOptions: {
        title: {
          text: '使用率',
          left: 'center',
          bottom: '0'
        },
        tooltip: {
          // trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'right'
        },
        series: [
          {
            name: '优惠券总数',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 0, name: '已使用' },
              { value: 0, name: '未使用' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      isAddNurse: false,
      keywords: '',
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      tableData: [],
    }
  },
  filters: {
    formatDate
  },
  mounted() {
    this.id = this.$route.params.id
    this.init()
  },
  methods: {
    init() {
      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    handleSend() {
      this.$refs.sendDiscount.handleOpen(this.id)
    },
    getList() {
      this.tableLoading = true
      const { id: coupon_batch, keywords } = this
      const params = {
        coupon_batch,
        keywords
      }
      this.tableLoading = true
      fetchCouponDetail(params)
        .then(res => {
          if (res.status) {
            const { list, info: { num, send_num, used_num }, total } = res.data
            this.tableData = list
            this.total = total
            this.totalChartsOptions.title.text = `优惠券总量：${num}`
            // this.totalChartsOptions.series[0].data[0].name = `已发放：${send_num}`
            this.totalChartsOptions.series[0].data[0].value = send_num
            this.totalChartsOptions.series[0].data[1].value = num - send_num
            // this.totalChartsOptions.series[0].data[1].name = `未发放：${num - send_num}`
            this.totalUsedChartsOptions.title.text = `使用率 ${((used_num / send_num) * 100).toFixed(2)}%`
            this.totalUsedChartsOptions.series[0].data[0].value = used_num
            this.totalUsedChartsOptions.series[0].data[1].value = send_num - used_num
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .charts {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  .total-charts {
    width: 400px;
    height: 250px;
  }

  .el-pagination {
    margin-top: 20px;
  }
</style>
